export enum StatisticsTypeEnum {
  READY_TO_BOOK = "readyToBook",
  PENDING_QUOTES = "pendingQuotes",
  CONFIRMED_BOOKING = "confirmedBookings",
  DELIVERED = "deliveredPackages",
}
